var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 6.51247V7.00313C12.3327 8.15322 11.9603 9.27229 11.2717 10.1934C10.583 11.1146 9.6151 11.7885 8.51221 12.1145C7.40931 12.4406 6.23056 12.4015 5.15174 12.0029C4.07292 11.6043 3.15184 10.8677 2.52587 9.9029C1.8999 8.93808 1.60258 7.79677 1.67825 6.64917C1.75392 5.50157 2.19853 4.40917 2.94577 3.53491C3.69301 2.66064 4.70284 2.05134 5.82465 1.79788C6.94647 1.54442 8.12016 1.66038 9.17069 2.12847M12.3333 2.73341L7.00002 8.07208L5.40002 6.47208",
    stroke: "#1ECB4F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/iconCheck.30b5940c0b8127a3d1853e272a0ef55a.svg";
export { ForwardRef as ReactComponent };